import {Injectable, Inject} from 'ng-metadata/core';
import {getVid,getInstitutionCode} from '../appConfig/appConfigForward';
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import appConfigModule from '../appConfig/appConfig.module';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/doc.interfcae';

@Injectable()
export class RtaService {

	constructor(@Inject('$http') private $http : ng.IHttpService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
				private configurationUtil: ConfigurationUtil,
				@Inject('$stateParams') private $stateParams : ng.ui.IStateParamsService) {
	}

	public updateAvailability(docs:PrimoResponse.IDoc[], rtaParams : IRtaParams = {}) {
		let rtaUrl:string =  this.calcRtaUrl(docs);
		if (!rtaUrl) {
			return;
		}

		let rtaPayload: IRtaPayload = this.calcRtaPayload(docs, rtaParams);
        if (!rtaPayload) {
            return;
        }
		this.setRtaInProgress(docs, true);
		rtaUrl = rtaUrl.replace(/(https?:\/\/[^\/]*)/, '').replace('//','/');
		this.$http.post(rtaUrl, rtaPayload)
			.then((response) => this.onSuccess(response, docs), this.onError)
			.finally(() => {
				this.setRtaInProgress(docs,false);
			});
	}

	private calcRtaUrl(docs:PrimoResponse.IDoc[]){
		let rtaArr = docs.map((doc) => {
			if (doc['@rta_link'] && doc['@rta_link'].length > 0) {
				return doc['@rta_link'];
			}

		}).filter(this.filterEmpty);
		let regex = '.*recordInformation=';
		if (rtaArr.length > 0 && rtaArr[0]) {
			let match = rtaArr[0].match(regex);
			if (match != null) {
				let prefix =  match[0];

				return prefix.replace('recordInformation=','');
			}
		}
		return null;
	}

	private calcRtaPayload(docs:PrimoResponse.IDoc[], rtaParams :IRtaParams):IRtaPayload{
		let rtaArr = docs.map((doc) => {
 			if (doc['@rta_link'] && doc['@rta_link'].length > 0 && doc.context !== 'PC') {
				return doc['@rta_link'];
			}
		}).filter(this.filterEmpty);
		let regex = '.*recordInformation=';
		let rtaResultLink = '';
		if (rtaArr.length > 0 && rtaArr[0]) {
			let match = rtaArr[0].match(regex);
			if (match != null) {
				for (let i = 0; i < rtaArr.length; i++) {
					let regExp = new RegExp('.*recordInformation=');
					let str = rtaArr[i].replace(regExp,'');
					rtaResultLink += str;
					if (i !== rtaArr.length - 1) {
						rtaResultLink += '|;|';
					}
				}

				let rtaPayload = {
                    records: docs,
					recordsData : rtaResultLink,
					instCode: getInstitutionCode(),
					vid: getVid(),
					rtaOnAllInstitutions: 'false',
                    instSort: this.configurationUtil.getLocationsConfiguration().instsort,
                    selectedScope: this.$stateParams.search_scope,
					lang:this.$translate.use(),
				};

				//Override rtaPayload with rtaParams
				Object.assign(rtaPayload, rtaParams);

				return rtaPayload;
			}
		}
		return;
	}

	private setRtaInProgress(docs:PrimoResponse.IDoc[], isInProgress:boolean){
		docs.forEach((doc)=>{
			if(doc['@rta_link']) {
				doc.rtaInProgress = isInProgress;
			}
		});
	}

	private onSuccess(response, docs:PrimoResponse.IDoc[]) :angular.IPromise<any>{
		if(response.status !== 200){
            return response;
        }
		let rtaData = response.data;
        if (!rtaData) {
             return response;
        }
		docs.forEach((doc) => {
			let recordid:string = doc.pnx.control.recordid;
			if (rtaData[recordid] &&
				rtaData[recordid].delivery.availability &&
				rtaData[recordid].delivery.holding.length > 0) {
				doc.pnx.delivery.availability = rtaData[recordid].delivery.availability;
				doc.pnx.delivery.displayedAvailability = rtaData[recordid].delivery.availability[0];
				doc.pnx.delivery.holding = rtaData[recordid].delivery.holding;
				doc.pnx.delivery.bestlocation = rtaData[recordid].delivery.bestlocation;
				doc.pnx.delivery.physicalItemTextCodes = rtaData[recordid].delivery.physicalItemTextCodes;
				doc.pnx.delivery.feDisplayOtherLocations = rtaData[recordid].delivery.feDisplayOtherLocations;
                if (!doc.delivery) {
                    doc.delivery = {};
                }
			    doc.delivery.availability = rtaData[recordid].delivery.availability;
			    doc.delivery.displayedAvailability = rtaData[recordid].delivery.availability[0];
			    doc.delivery.holding = rtaData[recordid].delivery.holding;
			    doc.delivery.bestlocation = rtaData[recordid].delivery.bestlocation;
			    doc.delivery.formatedDueDate = rtaData[recordid].delivery.formatedDueDate;
                if (doc.delivery.bestlocation) {
			       doc.delivery.bestlocation.pendingRender = true;
                } 
			    doc.delivery.physicalItemTextCodes = rtaData[recordid].delivery.physicalItemTextCodes;
			    doc.delivery.feDisplayOtherLocations = rtaData[recordid].delivery.feDisplayOtherLocations;
                    
                //almaInstitutionsList
                if (doc.cameFrom === 'full' || rtaData[recordid].delivery.almaInstitutionsList){
                    doc.delivery.almaInstitutionsList = rtaData[recordid].delivery.almaInstitutionsList;
                }
				
				
				
                
                /* PRM-36186
                 * New UI invokes RTA for Online Resource records (and breaks results for others)
                 * When user search for a record and click the record in the results list (brief),
                 * The RTA call from 'brief view' can finish after the RTA call from 'full view'
                 * In this case, the locations is set from wrong item (rtaData) and override the correct one in the 'full view' 
                 */
                if (docs.length === 1) {
                    //this.locationsService.setLocations(rtaData[recordid]);
                }
			}
		});
		

		return response;
	}

	private onError(err): angular.IPromise<any>{
		console.error('RTA request failed', err);
		return err;
	}

	private filterEmpty(item) {
		return item;
	}

}

interface IRtaPayload{
	recordsData :string;
	instCode :string;
	vid :string;
	lang :string;
	rtaOnAllInstitutions: string;
}

export interface IRtaParams{
	instCode ?:string;
	vid ?:string;
	lang ?:string;
	rtaOnAllInstitutions ?: string;
}

/**

class RTAPayload{

	constructor(recordsData:string, instCode:string, vid:string, lang:string) {
		this.recordsData = recordsData;
		this.instCode = instCode;
		this.vid = vid;
		this.lang = lang;
	}

	public recordsData :string;
	public instCode :string;
	public vid :string;
	public lang :string;
}
*/
export default [ appConfigModule.name ];




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/rta.service.ts